import { getInstitutionList } from "@/services/institution";


const state = {
  institutions: [],

}

const mutations = {
  setInstitutions(state, payload) {
    state.institutions = payload;
  },
}

const getters = {
  institutions(state){
    return state.institutions
  },
}

const actions = {
  actionSetInstitutions({commit}) {
    return new Promise((resolve, reject) => {
      getInstitutionList().then((response) => {
        commit('setInstitutions', response.data)
        resolve(response.data);
      }, (error) => {
        reject(error);
      });
    })
  },
}

export default {
  state,
  mutations,
  getters,
  actions,
  namespaced: true
}
